import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import LogoWrapper from './LogoWrapper';
import AvatarWrapper from './AvatarWrapper';
// Use default export for compatibility with existing imports
function Header() {
    return (_jsxs("header", { className: "fixed top-0 pb-6 z-50 flex w-full shrink-0 justify-between p-4", style: { height: '64px' }, children: [_jsx(LogoWrapper, {}), _jsx(AvatarWrapper, {})] }));
}
export default Header;
